import React from 'react'
import baseLoadable from '@loadable/component'

import SpinnerLoader from '../Loaders/SpinnerLoader'

export function loadable(func) {
  return baseLoadable(func, { fallback: <SpinnerLoader /> })
}